var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1854 151.522C50.8589 151.197 48.9618 149.416 48.5473 147.057L32.7379 57.2316C32.1554 53.9188 34.7153 50.8848 38.093 50.8848H42.7908L42.7945 50.9089H38.3394C35.9756 50.9089 34.1794 53.0264 34.5771 55.3484L50.4425 147.852C50.7226 149.486 51.7719 150.825 53.1854 151.522Z",
    fill: "#0E171E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8104 94.7477L94.2081 85.6032M91.6463 70.8647L88.8874 55.2371C88.4486 52.7348 86.2677 50.9092 83.7153 50.9092H38.3391C35.9753 50.9092 34.1791 53.0267 34.5768 55.3486L50.4422 147.852C50.7222 149.487 51.7716 150.825 53.1851 151.522C53.8647 151.859 54.6302 152.047 55.4331 152.047H99.379C102.757 152.047 105.32 149.011 104.738 145.698L102.022 130.199",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5672 55.8775H58.4849C57.7115 55.8775 57.0845 55.2532 57.0845 54.4832C57.0845 53.7131 57.7115 53.0889 58.4849 53.0889H68.5672C69.3407 53.0889 69.9676 53.7131 69.9676 54.4832C69.9676 55.2532 69.3407 55.8775 68.5672 55.8775Z",
    fill: "#0E171E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9012 152.013H170.793",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9346 125.476C91.8969 134.41 91.8603 143.079 91.8225 152.013C86.6434 151.98 81.4643 151.946 76.2852 151.912C75.8348 145.1 75.3845 138.289 74.9341 131.477C73.0877 138.322 71.2412 145.168 69.3947 152.013C64.6611 152.001 59.9275 151.989 55.1939 151.977C54.8216 151.969 54.1175 151.902 53.3712 151.487C52.8625 151.204 52.5158 150.86 52.3036 150.612C55.5218 138.471 58.6292 126.748 61.8473 114.607",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5571 125.417L75.4253 128.013L74.7042 132.094L79.5571 125.417Z",
    fill: "#0E171E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4766 72.9009L82.3136 73.9521C82.2949 73.1772 82.2744 72.3501 82.2557 71.5752C83.0903 71.7881 83.91 72.0625 84.6998 72.4229C84.9743 72.548 85.2562 72.6974 85.4766 72.9009Z",
    fill: "#0E171E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0016 70.7109C75.8223 72.4941 75.6748 74.3276 75.4974 76.1108L72.8778 76.9492L65.1122 72.171C65.086 72.1542 65.0562 72.1561 65.0338 72.1692C65.0954 71.8219 65.2503 71.4933 65.5043 71.215C66.1279 70.5298 67.1269 70.3692 68.0063 70.302C70.4261 70.119 72.8535 70.4252 75.2715 70.6456C75.5142 70.668 75.7569 70.6885 76.0016 70.7109Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0933 102.44C79.3523 95.6022 78.2117 87.1608 77.8721 82.0654C77.1103 81.7106 75.9377 81.0534 74.81 79.8808C73.7718 78.8034 73.1762 77.7093 72.842 76.9643C72.8364 76.9531 72.8326 76.9419 72.827 76.9307",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8071 96.158L83.0275 81.3225C83.0275 81.3225 84.7621 79.4553 85.3484 77.4052C85.9216 75.3942 85.6397 73.6895 85.4585 72.9072C85.4585 72.9072 103.129 67.287 113.541 63.9951C113.884 64.2379 115.283 67.2141 117.202 70.7562C117.968 72.1715 117.398 73.9378 115.953 74.6399L91.5623 86.4797L92.5577 93.0241",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0338 72.1699V72.1718C65.0132 72.1811 64.9983 72.2035 64.9964 72.2315L64.8657 75.1537C64.8246 76.0873 65.2037 76.9891 65.8983 77.6127L67.0634 78.6602L62.4869 80.055C60.2986 80.7216 58.5845 82.4263 57.903 84.6091L52.4434 102.129C51.1083 106.414 53.2668 111.009 57.4175 112.716L74.8532 119.886",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.318 64.7266C112.862 68.0088 114.406 71.2909 115.95 74.5731",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.725 71.791L117.121 70.46",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.331 69.0045L115.752 67.8018",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.279 66.7697L114.625 65.6514",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6951 102.44C65.7909 98.0415 67.2743 92.753 68.3701 88.3545",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.064 78.6593C69.0436 78.0407 71.0232 77.4516 73.0027 76.833",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6582 86.4602L90.3014 83.5156",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0252 117.708L71.9864 118.706L61.8473 114.606L61.0252 117.708Z",
    fill: "#0E171E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4099 109.352L64.6951 102.44",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.965 61.076C122.125 60.8318 122.346 60.4813 122.594 60.0502C123.375 58.6893 123.786 57.6246 123.967 57.1229C124.135 56.6582 124.512 55.5533 124.372 54.4208C124.345 54.1938 124.289 53.9067 124.125 53.8578C123.864 53.7801 123.483 54.3508 123.359 54.5334C122.02 56.5004 118.496 60.2964 117.026 61.7042C116.47 62.2363 115.597 63.0111 114.397 63.8333L117.414 71.2641C117.942 70.9689 118.681 70.486 119.419 69.7329C119.584 69.5636 120.064 69.0594 120.725 68.0216C121.369 67.0087 122.37 65.4047 122.751 63.2027C122.823 62.7893 123.12 61.071 122.622 60.8576C122.564 60.833 122.456 60.8111 122.143 60.9735C121.802 61.1506 121.248 61.5315 120.679 62.5948C120.459 63.0066 120.184 63.6198 120.004 64.4187",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.541 64.0247L115.565 62.9736C115.565 62.9736 117.795 70.9776 117.414 71.2642C115.973 68.5695 113.541 64.0247 113.541 64.0247Z",
    fill: "#0E171E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3267 67.1148C74.0374 66.8214 73.348 66.0406 73.2121 64.8686C73.0329 63.3235 73.9441 62.1878 74.2592 61.795C76.3581 59.1781 80.6888 60.0137 80.8658 60.0505C81.304 59.7073 81.748 59.3507 82.1967 58.9802C82.6266 58.6253 83.0431 58.2722 83.4465 57.9219C83.8346 58.1045 84.1222 58.6635 84.1101 59.0185C84.0826 59.8306 83.524 60.4952 81.8758 61.5416C81.7137 61.4542 81.457 61.3436 81.1327 61.3221C80.9767 61.3117 80.3781 61.2937 79.5114 61.9807C78.8113 62.5358 78.7264 62.9246 78.1773 63.5513C77.8133 63.9667 77.1303 64.552 76.1632 65.0221",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.392 66.1494C74.2606 66.2165 73.6897 66.5253 73.4631 67.1796C73.4167 67.3136 73.2193 67.9399 73.6151 68.5583C73.7025 68.6948 74.1912 69.4128 75.0506 69.3915C75.7052 69.3753 76.1837 68.5735 76.3963 67.9374C76.0692 67.8335 75.6466 67.6731 75.3581 67.3567C74.8757 66.8279 74.4662 66.5509 74.392 66.1494Z",
    fill: "#0E171E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4166 68.3808C85.2561 68.8326 84.7108 69.0772 83.6391 69.5552C83.0696 69.811 82.5711 69.9585 82.2182 70.0481C82.2312 70.5579 82.2424 71.0658 82.2555 71.5755C82.2742 72.3242 82.291 73.0748 82.3097 73.8236C82.3433 74.0999 82.6439 77.2517 79.6863 77.8679C76.5923 78.5121 75.4993 76.0898 75.4993 76.0898C75.6767 74.3066 76.1737 68.9368 76.2596 68.0779C74.8293 67.1517 73.9932 66.1121 74.2229 65.3354C74.2378 65.2868 74.3461 64.9395 74.6636 64.779C75.0482 64.5848 75.3131 64.5329 76.1409 65.0071L75.6584 64.7617L80.0675 61.0098L81.1837 62.4823C81.6095 63.0369 82.2742 63.8827 83.12 64.891C84.8583 66.9673 85.6575 67.6974 85.4166 68.3808Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5145 64.6945C75.9455 65.2028 76.77 65.3622 77.3874 65.2236C78.1496 65.0525 78.7223 64.3343 78.7344 63.4842C79.0106 63.5485 79.485 63.6318 80.0686 63.5855C80.3515 63.5631 82.2931 63.4092 82.7538 62.1669C82.7917 62.0646 82.9324 61.6821 82.8045 61.2549C82.5712 60.4757 82.1349 59.9273 80.8498 59.9615C79.317 61.5124 77.0473 63.1436 75.5145 64.6945Z",
    fill: "#0E171E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3617 65.8271C75.4813 65.9813 75.6298 66.1511 75.8121 66.3225C76.0632 66.5589 76.3103 66.7343 76.5214 66.863",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.389 64.8018C80.6029 65.1622 80.8269 65.3914 80.997 65.5364C81.1348 65.6538 81.2817 65.7539 81.3517 65.9502C81.4179 66.136 81.3838 66.3199 81.3432 66.4484",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9536 67.4785C79.0995 67.6002 79.4128 67.8275 79.874 67.9176C80.2478 67.9907 80.5583 67.9423 80.7353 67.9007",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4047 66.195C78.4112 66.1378 78.4422 65.9259 78.6242 65.7643C78.7401 65.6614 78.8644 65.6258 78.9282 65.6123",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9126 64.219C80.9267 64.1627 80.9771 63.9929 81.1406 63.8728C81.2269 63.8095 81.313 63.7832 81.3686 63.7715",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3193 73.2931L79.3366 71.5271C79.0178 71.3154 79.0883 70.8283 79.4541 70.7157C80.3787 70.4311 82.2355 69.8584 82.2355 69.8584L82.3193 73.2931Z",
    fill: "#0E171E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.422 109.93L88.2765 91.0117L120.567 107.022L107.833 132.557L89.8672 124.33",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.592 97.1182C96.1334 105.87 92.5837 112.838 88.1252 121.59",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2613 113.508L90.2354 100.3C90.2354 100.3 97.1398 98.1789 100.592 97.1182",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2356 100.3C89.5939 97.2828 88.9521 94.2654 88.3104 91.248",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M112.292 105.671L110.755 108.722L115.822 111.126L117.376 108.17L112.292 105.671Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.837 109.922L114.958 112.329",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6672 108.291C79.8703 102.531 84.0735 96.7714 88.2766 91.0117C84.9855 97.3377 81.6944 103.664 78.4033 109.99C77.4912 109.423 76.5792 108.857 75.6672 108.291Z",
    fill: "#0E171E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0937 111.662C80.5838 111.936 85.7534 115.128 86.2245 115.473C86.7051 115.825 88.7436 116.975 88.482 118.096C88.4459 118.251 88.2963 118.428 88.2681 118.456C87.9318 118.787 87.0795 118.417 86.7195 118.261C86.2061 118.038 85.5747 117.443 84.8617 116.855",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7823 116.663C85.2499 117.82 85.7869 118.648 86.1844 119.185C87.4413 120.881 89.0852 122.678 89.0852 122.678C89.0852 122.678 90.0491 123.733 89.8666 124.33C89.7916 124.576 89.6244 124.693 89.6244 124.693C89.6244 124.693 89.4934 124.785 89.3051 124.798C88.3723 124.861 87.2008 123.73 87.2008 123.73C86.5564 123.108 85.5861 122.066 84.5311 120.479",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4741 120.746C82.877 121.745 83.372 122.472 83.7461 122.945C84.3322 123.685 85.18 124.757 86.353 124.923C86.9777 125.012 87.5959 124.873 87.5959 124.873C87.9259 124.799 88.1907 124.688 88.3788 124.594",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2913 121.312C80.8733 122.101 81.3918 122.713 81.7831 123.149C81.8799 123.257 82.2535 123.67 82.8091 124.128C83.2964 124.529 83.5159 124.63 83.6833 124.688C84.1833 124.862 84.6128 124.802 84.7355 124.782C85.0198 124.735 85.2406 124.638 85.3831 124.562",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2863 119.931L79.4382 122.872C79.4382 122.872 80.2355 123.551 81.3193 123.925C81.4989 123.987 81.7361 124.041 82.0032 123.981C82.1614 123.946 82.2819 123.881 82.3574 123.833",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4388 118.819C74.1294 115.653 75.7745 112.573 77.4652 109.407C78.2296 109.862 78.9361 110.389 79.6714 110.881C80.0884 111.159 80.2162 111.714 79.9674 112.15C79.092 113.682 78.2393 115.185 77.3807 116.696C76.871 117.593 76.3592 118.492 75.8392 119.402C75.5954 119.829 75.0663 120.004 74.6186 119.801C73.8925 119.473 73.1779 119.123 72.4388 118.819Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2609 111.662C77.2366 112.173 78.235 112.696 79.2107 113.206",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0322 113.962C76.0262 114.487 77.0203 115.012 78.0143 115.537",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6724 116.509C74.6589 117.035 75.537 117.503 76.5235 118.03",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M136.859 136.071L139.184 152.013H168.746L159.153 129.215",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M149.309 129.59C151.708 137.087 154.107 144.584 156.506 152.081",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.469 134.216C143.607 134.565 145.98 140.354 150.527 140.698C151.127 140.744 151.889 140.704 152.776 140.423",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.198 152.047C143.018 150.842 142.837 149.637 142.657 148.433",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M125.116 65.2967C125.168 65.0685 125.887 61.8205 124.463 60.9057C124.419 60.8774 123.809 60.4959 123.404 60.7255C123.033 60.9364 123.101 61.5113 122.875 62.8084C122.875 62.8084 122.797 63.2551 122.56 64.2271C122.395 64.9023 122.093 65.8696 121.49 67.0305C121.147 68.0334 121.155 68.8659 121.197 69.3499C121.278 70.2623 121.572 70.9276 121.851 71.5566C122.183 72.3085 122.691 73.2823 122.978 73.6825L128.426 70.1831C128.269 70.0088 128.05 69.7501 127.819 69.4149C127.6 69.098 127.303 68.6914 127.165 68.224C127.016 67.7227 127.043 67.3134 127.12 66.6252C127.292 65.0786 127.468 64.361 127.615 63.1349C127.702 62.4058 127.746 62.0412 127.75 61.6037C127.761 60.494 127.552 59.8229 127.142 58.2486C126.339 55.1644 126.109 53.7885 125.634 53.79C125.582 53.7902 125.545 53.8068 125.499 53.8286C124.816 54.1493 124.832 55.6774 124.868 57.3028C124.903 58.886 124.954 60.3064 125.007 61.5344",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M122.872 73.6822L127.988 69.0195L129.234 70.4046L122.872 73.6822Z",
    fill: "#0E171E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M146.485 99.5842L132.807 72.502L123.806 77.0519C122.62 77.6514 122.155 79.1064 122.774 80.2824L135.559 103.96",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M123.692 77.0175L122.019 74.2246L131.308 69.3945L132.686 72.4564L123.692 77.0175Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M141.972 99.2449C138.33 99.6274 134.917 103.256 134.83 107.335L134.45 125.127L117.73 127.627L119.462 137.665C119.694 139.01 121.021 139.874 122.345 139.541L143.16 134.305C145.322 133.761 146.882 131.879 147.015 129.653L159.868 129.356C160.624 129.339 161.374 129.495 162.06 129.814L144.73 96.1777",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M159.18 129.477C159.631 130.501 160.083 131.525 160.535 132.549C160.833 132.42 162.011 131.872 162.278 130.829C162.326 130.644 162.424 130.26 162.223 129.953C162.067 129.714 161.81 129.643 161.442 129.547C161.26 129.499 160.906 129.423 159.719 129.456C159.492 129.463 159.305 129.471 159.18 129.477Z",
    fill: "#0E171E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.511 128.154C114.97 131.592 115.43 135.031 115.889 138.469C117.092 138.256 118.193 138.037 119.396 137.823C118.807 134.423 118.243 131.133 117.654 127.732C116.581 127.908 115.584 127.978 114.511 128.154Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M133.64 125.248C134.406 125.121 135.171 124.995 135.936 124.868",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M147.015 129.653C147.024 129.245 147.027 128.739 147.013 128.156C147.013 128.156 147.005 127.865 146.992 127.571C146.925 126.068 145.274 114.982 145.511 114.93C145.607 114.909 146.074 116.694 146.964 120.094C147.787 123.238 148.304 125.359 148.512 126.219C148.842 127.58 149.112 128.733 149.31 129.59C148.545 129.611 147.78 129.632 147.015 129.653Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M114.605 128.857C112.984 129.024 111.449 129.093 109.573 129.129C107.644 129.166 105.836 129.113 104.167 129.001C103.989 128.99 103.859 129.168 103.928 129.332C103.955 129.394 103.987 129.46 104.024 129.528C104.369 130.148 104.98 130.478 106.899 131.139C107.371 131.301 107.981 131.504 108.7 131.724C108.394 131.939 107.813 132.338 107.057 132.794C103.256 135.082 100.211 135.672 100.2 136.949C100.199 137.036 100.199 137.187 100.3 137.31C100.713 137.815 102.276 137.17 104.591 136.138C105.88 135.562 107.545 134.804 109.488 133.875",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M101.969 137.224C102.007 137.486 102.105 137.85 102.394 138.094C102.98 138.586 104.03 138.317 106.499 137.27C107.57 136.815 109.014 136.17 110.704 135.311",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M104.718 137.974C104.77 138.166 104.894 138.493 105.199 138.706C105.199 138.706 105.5 138.916 105.975 138.908C106.686 138.897 108.877 137.99 111.717 136.493",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M108.017 138.27C108.006 138.43 108.017 138.66 108.161 138.835C108.504 139.252 109.425 139.14 111.802 138.317C112.789 137.975 114.033 137.553 115.669 136.821",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M114.605 128.767L113.564 137.577L115.806 136.638L114.605 128.767Z",
    fill: "#0E171E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M110.656 126.898C108.402 127.48 106.163 128.352 103.909 128.934C104.575 129.36 109.551 129.06 109.551 129.06L110.656 126.898Z",
    fill: "#0E171E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M145.983 99.4456C141.048 97.9282 137.653 101.28 137.653 101.28C137.653 101.28 137.252 96.7401 137.099 95.9969C136.787 95.7878 136.498 95.6142 136.24 95.4704C134.69 94.6096 133.111 94.2194 132.851 93.0057C132.769 92.6229 132.829 92.2626 132.829 92.2626C132.911 91.7659 133.144 91.6053 133.518 90.9387C133.887 90.2778 134.072 89.9491 134.02 89.5832C133.956 89.1295 133.43 88.967 133.471 88.4797C133.475 88.4237 133.484 88.3191 133.544 88.2127C133.8 87.7683 134.53 88.054 135.17 87.7477C135.529 87.576 135.599 87.3444 136.33 86.0355C136.548 85.6453 137.349 84.3255 137.764 83.6328C137.764 83.6328 148.956 100.36 145.983 99.4456Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M135.977 88.4521C136.063 88.5475 136.19 88.6663 136.364 88.7726C136.61 88.9231 136.843 88.983 136.994 89.009",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M138.75 90.1458C138.827 90.1721 138.994 90.2172 139.201 90.1796C139.388 90.1455 139.519 90.0595 139.583 90.0107",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M135.114 90.776C135.189 90.8121 135.337 90.8708 135.53 90.8661C135.764 90.8604 135.932 90.7655 136.003 90.7197",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M137.489 83.6041C137.406 83.6657 136.526 84.3333 136.42 85.3605C136.259 86.9112 137.912 88.8047 139.381 88.9521C139.659 88.9801 140.102 88.9625 140.45 89.2786C140.75 89.551 140.915 90.0123 140.844 90.4271C140.75 90.982 140.297 91.0975 139.887 91.6318C139.265 92.4441 139.327 93.4652 139.358 93.9849C139.444 95.4069 140.262 96.3784 140.675 96.8559C143.416 100.021 149.089 100.031 150.11 98.6069C150.202 98.4788 150.268 98.3309 150.268 98.3309C150.789 97.1638 149.786 95.7102 149.485 95.2463C147.095 91.5622 148.022 87.2117 144.245 84.5499C142.263 83.1536 139.18 82.3584 137.489 83.6041Z",
    fill: "#0E171E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M137.4 98.7405L139.468 97.1482L137.099 95.7969L137.4 98.7405Z",
    fill: "#0E171E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAddress);
export default __webpack_public_path__ + "static/media/no-address.7eaa518b6eff2239c485f1d538deb678.svg";
export { ForwardRef as ReactComponent };